import { render, staticRenderFns } from "./AnimalsOfAntarctica.vue?vue&type=template&id=5b44069e&"
import script from "./AnimalsOfAntarctica.vue?vue&type=script&lang=js&"
export * from "./AnimalsOfAntarctica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports